import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import superAdminLoginService from "./superAdminLoginService";
import { User } from "../../../pages/login/login.model";
import { StorageService } from "../../../core/storageService/storageService";

interface AuthState {
  superAdminUser: User | any;
  isError: boolean;
  isSuccess: boolean;
  isLoading: boolean;
  message: string;
}


const userFromLocalStorage = StorageService.getObjStorage("super_admin_user");
let user: User | null;
const isSavePassword = localStorage.getItem("super_admin_save_password") === "true";
const isFirstLogin = sessionStorage.getItem("super_admin_is_first_login");
user = userFromLocalStorage ? JSON.parse(userFromLocalStorage) : null;

if (user && (isSavePassword || isFirstLogin)) {
  user = user;
} else {
  user = null
}

const initialState: AuthState = {
  superAdminUser: user ? user : "",
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

//Login User
export const superAdminLogin = createAsyncThunk(
  "auth/login",
  async (userData: User, thunkAPI) => {
    try {
      const response = await superAdminLoginService.superAdminAuthService(userData);

      if (response.isSuccess) {
        // localStorage.setItem("reg_code", userData.reg_code || "");
        StorageService.setObjStorage("super_admin_user", JSON.stringify({
          ...response,
          access_token: response?.result?.access_token,
          refresh_token: response?.result?.refresh_token,
        }));
        StorageService.setObjStorage("super_admin_access_token",response?.result?.access_token)
        StorageService.setObjStorage("super_admin_refresh_tokenn",response?.result?.refresh_token)

        return response;
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//Logout User
// export const logout = createAsyncThunk("auth/logout", async () => {
//   await loginService.logout();
// });
export const clearUserDataFromLocalStorage = () => {
  localStorage.removeItem("super_admin_user");
};

export const superAdminAuthSlice = createSlice({
  name: "superAdminAuth",
  initialState,
  reducers: {
    resetSuperAdminAuth: (state) => {
      state.superAdminUser = "";
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = "";
      clearUserDataFromLocalStorage();
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(superAdminLogin.pending, (state, action: PayloadAction<any>) => {
        state.isLoading = true;
      })
      .addCase(superAdminLogin.fulfilled, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.superAdminUser = {
          ...action?.payload,
          token: action?.payload?.result?.user_data?.token,
          isSuperAdmin: action?.payload?.isSuperAdmin
        };
      })
      .addCase(superAdminLogin.rejected, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action?.payload
        state.superAdminUser = "";
      });
  },
});

export const { resetSuperAdminAuth } = superAdminAuthSlice.actions;
// export default authSlice.reducer;
